const initRawFoodCalc = (root) => {
  if (root.dataset.rawFoodCalcInit === 'true') {
    return;
  }

  const dialog = root.querySelector('.raw-food-calc__dialog');
  const openBtn = root.querySelector('.raw-food-calc__open');
  const closeBtn = root.querySelector('.raw-food-calc__close');
  const yearsSelect = root.querySelector('.raw-food-calc__years');
  const monthsSelect = root.querySelector('.raw-food-calc__months');
  const weightInput = root.querySelector('.raw-food-calc__weight');
  const activitySelect = root.querySelector('.raw-food-calc__activity');
  const calcBtn = root.querySelector('.raw-food-calc__submit');
  const resultEl = root.querySelector('.raw-food-calc__output');
  const i18nEl = root.querySelector('.raw-food-calc__i18n');

  if (
    !dialog ||
    !openBtn ||
    !closeBtn ||
    !yearsSelect ||
    !monthsSelect ||
    !weightInput ||
    !activitySelect ||
    !calcBtn ||
    !resultEl ||
    !i18nEl
  ) {
    return;
  }

  let i18n = {};

  try {
    i18n = JSON.parse(i18nEl.textContent.trim());
  } catch {
    return;
  }

  root.dataset.rawFoodCalcInit = 'true';

  const escapeHtml = (s) =>
    String(s)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');

  const pouchLine = (count) =>
    escapeHtml(String(i18n.pouches || '').replace(/\[\[count\]\]/g, String(count)));

  openBtn.addEventListener('click', () => {
    if (typeof dialog.showModal === 'function') {
      dialog.showModal();
    }
  });

  closeBtn.addEventListener('click', () => {
    if (typeof dialog.close === 'function') {
      dialog.close();
    }
  });

  dialog.addEventListener('click', (e) => {
    if (e.target === dialog && typeof dialog.close === 'function') {
      dialog.close();
    }
  });

  for (let i = 0; i <= 20; i++) {
    const opt = document.createElement('option');
    opt.value = String(i);
    opt.textContent = String(i);
    yearsSelect.appendChild(opt);
  }

  for (let i = 0; i < 12; i++) {
    const opt = document.createElement('option');
    opt.value = String(i);
    opt.textContent = String(i);
    monthsSelect.appendChild(opt);
  }

  const toKg = (g) => (g / 1000).toFixed(2);

  calcBtn.addEventListener('click', () => {
    const years = Number.parseInt(yearsSelect.value || '0', 10);
    const months = Number.parseInt(monthsSelect.value || '0', 10);
    const weight = Number.parseFloat(weightInput.value);
    const activity = activitySelect.value;

    if (!weight || !activity) {
      resultEl.textContent = i18n.incomplete || '';
      return;
    }

    const totalMonths = years * 12 + months;
    const isPuppy = totalMonths < 12;
    let percent = 0;

    if (isPuppy) {
      if (activity === 'low') percent = 2.5;
      else if (activity === 'normal') percent = 3;
      else if (activity === 'high') percent = 4;
    } else {
      if (activity === 'low') percent = 2;
      else if (activity === 'normal') percent = 2;
      else if (activity === 'high') percent = 3;
    }

    const gramsPerDay = Math.round(weight * (percent / 100) * 1000 * 1.5);
    const gramsPerWeek = gramsPerDay * 7;
    const gramsPerFortnight = gramsPerDay * 14;
    const gramsPerMonth = gramsPerDay * 31;

    const pouchesPerWeek = Math.ceil(gramsPerWeek / 500);
    const pouchesPerFortnight = Math.ceil(gramsPerFortnight / 500);
    const pouchesPerMonth = Math.ceil(gramsPerMonth / 500);

    resultEl.innerHTML = `
      <div class='raw-food-calc__results'>
        <div class='raw-food-calc__result-block'>
          <span class='raw-food-calc__result-label'>${escapeHtml(i18n.dailyFeed)}</span>
          <span class='raw-food-calc__result-value'>${toKg(gramsPerDay)}kg</span>
        </div>
        <div class='raw-food-calc__result-block'>
          <span class='raw-food-calc__result-label'>${escapeHtml(i18n.weeklyFeed)}</span>
          <span class='raw-food-calc__result-value'>${toKg(gramsPerWeek)}kg</span>
          <span class='raw-food-calc__result-pouches'>${pouchLine(pouchesPerWeek)}</span>
        </div>
        <div class='raw-food-calc__result-block'>
          <span class='raw-food-calc__result-label'>${escapeHtml(i18n.fortnightlyFeed)}</span>
          <span class='raw-food-calc__result-value'>${toKg(gramsPerFortnight)}kg</span>
          <span class='raw-food-calc__result-pouches'>${pouchLine(pouchesPerFortnight)}</span>
        </div>
        <div class='raw-food-calc__result-block'>
          <span class='raw-food-calc__result-label'>${escapeHtml(i18n.monthlyFeed)}</span>
          <span class='raw-food-calc__result-value'>${toKg(gramsPerMonth)}kg</span>
          <span class='raw-food-calc__result-pouches'>${pouchLine(pouchesPerMonth)}</span>
        </div>
        <p class='raw-food-calc__note'>${escapeHtml(i18n.vetNote)}</p>
      </div>
    `;
  });
};

const bootstrapRawFoodCalcRoots = () => {
  for (const root of document.querySelectorAll('[data-raw-food-calc]')) {
    if (root.dataset.rawFoodCalcBootstrap === 'true') {
      continue;
    }

    root.dataset.rawFoodCalcBootstrap = 'true';

    const openBtn = root.querySelector('.raw-food-calc__open');
    if (!openBtn) {
      continue;
    }

    openBtn.addEventListener(
      'click',
      (e) => {
        if (root.dataset.rawFoodCalcInit === 'true') {
          return;
        }

        e.preventDefault();

        const dialog = root.querySelector('.raw-food-calc__dialog');
        initRawFoodCalc(root);

        if (root.dataset.rawFoodCalcInit === 'true' && dialog && typeof dialog.showModal === 'function') {
          dialog.showModal();
        }
      },
      { capture: true },
    );
  }
};

document.addEventListener('DOMContentLoaded', bootstrapRawFoodCalcRoots);
document.addEventListener('shopify:section:load', bootstrapRawFoodCalcRoots);
